/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationcolumnuser2Inputs */

const en_moderationcolumnuser2 = /** @type {(inputs: Moderationcolumnuser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reported user`)
};

const de_moderationcolumnuser2 = /** @type {(inputs: Moderationcolumnuser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeldete Person`)
};

/**
* | output |
* | --- |
* | "Reported user" |
*
* @param {Moderationcolumnuser2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationcolumnuser2 = /** @type {((inputs?: Moderationcolumnuser2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationcolumnuser2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationcolumnuser2(inputs)
	return de_moderationcolumnuser2(inputs)
});
export { moderationcolumnuser2 as "moderationColumnUser" }